import React, { useState } from 'react'
import styles from './style.module.scss'

interface AvatarProps {
  src: string
  alt: string
  link?: string
  className?: string
}

export const Avatar: React.FC<AvatarProps> = ({ src, alt, link, className }) => {
  const [imageError, setImageError] = useState(false)

  const imageElement = imageError ? (
    <div className={styles.placeholder} />
  ) : (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setImageError(true)}
    />
  )

  if (link) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        {imageElement}
      </a>
    )
  }

  return imageElement
}
